import { PureComponent } from 'react';

class PayU extends PureComponent {
    render() {
        const { payu } = this.props;

        if (!payu) {
            return null;
        }

        if (payu.length === 0) {
            return null;
        }

        const { action, fields } = JSON.parse(payu);
        const newFields = {};

        Object.keys(fields).map(key => {
            if (Array.isArray(fields[key])) {
                fields[key].map((value, index) => {
                    newFields[`${key}[${index}]`] = value;
                })
            } else {
                newFields[key] = fields[key];
            }
        })

        return (
            <form id="payu" action={ action } method="POST" encType="application/x-www-form-urlencoded">
                { Object.keys(newFields).map(key => {
                    return <input key={ key } name={ key } value={ newFields[key] ? newFields[key] : '' } type="hidden" />
                }) }
            </form>
        );
    }
}

export default PayU;
